import { useState } from 'react';
import { TextField, Button, Card, Typography } from '@mui/material';

export default function ContactForm() {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });

    const handleSubmit = (e) => {
        e.preventDefault();
        // 处理表单提交
    };

    return (
        <Card className="card">
            <Typography variant="h5" gutterBottom>联系我们</Typography>
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    label="姓名"
                    margin="normal"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
                <TextField
                    fullWidth
                    label="邮箱"
                    type="email"
                    margin="normal"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
                <TextField
                    fullWidth
                    label="留言"
                    multiline
                    rows={4}
                    margin="normal"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="shine-button"
                    sx={{ mt: 2 }}
                >
                    提交
                </Button>
            </form>
        </Card>
    );
}
